import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { OpenIdError } from '../lib/oauth4webapi/OpenIdError';
import { getUmaPermissions } from '../lib/oauth4webapi/getUmaPermissions';
import { useAuthorizationServerInfoQuery } from './useAuthorizationServerInfoQuery';
export const useUmaPermissionsQuery = ({ audience, issuerUrl, accessToken, }) => {
    const { data: authorizationServer } = useAuthorizationServerInfoQuery(issuerUrl);
    const hasAllParams = !!authorizationServer && !!accessToken;
    return useQuery({
        queryFn: () => {
            if (!hasAllParams)
                return null;
            return getUmaPermissions({
                authorizationServer,
                audience,
                accessToken,
            });
        },
        queryKey: ['umaPermissions', issuerUrl, accessToken, audience],
        enabled: hasAllParams,
        placeholderData: keepPreviousData,
        retry: (_failureCount, error) => {
            const isInvalidParametersError = error instanceof OpenIdError;
            // Stop retrying only if our input parameters are invalid
            return !isInvalidParametersError;
        },
    });
};
